/**
 * VersionApiClient -- /api/v1/version
 * Gestión de versiones publicadas de apps del ecosistema.
 *
 * @module infrastructure/api/VersionApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/version';

export const VersionApiClient = {
  /**
   * Obtiene la versión estable actual de una app.
   * @param {string} app  ej: 'nexo_desktop'
   */
  async getStable(app) {
    return ApiBase.get(`${BASE}/stable?app=${encodeURIComponent(app)}`);
  },

  /**
   * Historial de versiones publicadas.
   * @param {string} app
   * @param {number} limit
   */
  async getHistory(app, limit = 10) {
    return ApiBase.get(`${BASE}/history?app=${encodeURIComponent(app)}&limit=${limit}`);
  },

  /**
   * Publica una nueva versión como estable.
   * @param {{ appName, version, releaseNotes, isStable }} data
   */
  async publish(data) {
    return ApiBase.post(`${BASE}/publish`, {
      app_name:      data.appName,
      version:       data.version,
      release_notes: data.releaseNotes,
      is_stable:     data.isStable !== false,
    });
  },
};
